export enum LevelSpecificationType {
    none = 0,
    best = 1,
    cover = 2
}
